import React from 'react'
import ReactDOM from 'react-dom'
import countries from 'app/constants/countries'
import SwColorChips from 'components/SwColorChips/SwColorChips'
import languages from 'app/constants/languages'

ReactDOM.render(<SwColorChips country={countries.us} lang={languages.en} />, document.getElementById('page-index-mount'))
